<div class="auth-page">
  <div class="auth-shell">
    <div class="auth-card">
      <div class="auth-brand">
        <img
          src="assets/favicon/android-chrome-192x192.png"
          [attr.alt]="'COMPONENTS.AUTH.BRAND_ALT' | translate"
          class="auth-brand-logo"
        />
        <h1 class="auth-brand-title">OrgLines</h1>
      </div>

      <form class="auth-form" [formGroup]="form" (ngSubmit)="submitForm()">
        <div>
          <label for="email-input" class="auth-field-label">{{ "INPUTS.EMAIL" | translate }}</label>
          <input
            id="email-input"
            type="email"
            class="input-field-lg auth-input w-full"
            [attr.placeholder]="'INPUTS.EMAIL' | translate"
            formControlName="email"
          />
        </div>

        <button
          type="submit"
          class="btn-primary auth-submit w-full rounded-xl"
          [disabled]="form.invalid"
        >
          {{ "BUTTONS.SEND_LINK" | translate }}
        </button>
      </form>

      <div class="auth-divider">
        <div class="auth-divider-line"></div>
        <span class="auth-divider-text">{{ "COMPONENTS.AUTH.OR" | translate }}</span>
        <div class="auth-divider-line"></div>
      </div>

      <div class="auth-links">
        <p>
          {{ "COMPONENTS.LOGIN.NO_ACCOUNT" | translate }}
          <a routerLink="/registration">{{ "COMPONENTS.LOGIN.REGISTER" | translate }}</a>
        </p>
        <p>
          {{ "COMPONENTS.REGISTRATION.HAVE_ACCOUNT" | translate }}
          <a routerLink="/login">{{ "COMPONENTS.REGISTRATION.LOGIN_LINK" | translate }}</a>
        </p>
      </div>
    </div>
    <p class="auth-footer-note">{{ "COMPONENTS.AUTH.FOOTER_NOTE" | translate }}</p>
  </div>
</div>

<app-toasts></app-toasts>

<ng-template #dangerTpl>
  {{ callbackError }}
</ng-template>

<ng-template #successTpl>
  {{ message }}
</ng-template>
